import api, { API_URL } from '../api/client'

export type DownloadFormat = 'png' | 'jpeg' | 'webp'

const STORED_WEBP = /\/users\/[^/?#]+\/[^?#]+\.webp(?:[?#]|$)/i
const STORED_IMAGE = /\/users\/[^/?#]+\/images\/[^?#]+\.(?:png|jpe?g|webp)(?:[?#]|$)/i
const PREVIEW_WEBP = /_preview\.webp(?:[?#]|$)/i

const BLOB_EXTENSIONS: Record<string, string> = {
	'image/jpeg': 'jpg',
	'image/png': 'png',
	'image/webp': 'webp',
	'audio/mpeg': 'mp3',
}

export function isStoredWebp(url: string): boolean {
	return (STORED_WEBP.test(url) || STORED_IMAGE.test(url)) && !PREVIEW_WEBP.test(url)
}

export function blobExtension(blob: Blob, fallback = 'jpg'): string {
	const type = blob.type.split(';')[0].trim().toLowerCase()
	return BLOB_EXTENSIONS[type] || type.split('/')[1] || fallback
}

export function withBlobExtension(name: string, blob: Blob): string {
	const ext = blobExtension(blob, '')
	if (!ext) return name
	const dot = name.lastIndexOf('.')
	const base = dot > 0 ? name.slice(0, dot) : name
	return `${base}.${ext}`
}

async function fetchConverted(url: string, format?: DownloadFormat): Promise<Blob | null> {
	const token = api.getToken()
	if (!token || !isStoredWebp(url)) return null
	const query = new URLSearchParams({ src: url })
	if (format) query.set('format', format)
	try {
		const response = await fetch(`${API_URL}/api/v1/files/original?${query}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
		return response.ok ? await response.blob() : null
	} catch {
		return null
	}
}

export async function fetchOriginalBlob(url: string, format?: DownloadFormat): Promise<Blob> {
	const converted = await fetchConverted(url, format)
	if (converted) return converted
	const response = await fetch(url)
	if (!response.ok) throw new Error(`HTTP ${response.status}`)
	return response.blob()
}
